import { render, staticRenderFns } from "./PhysicalPresenceTable.vue?vue&type=template&id=fbb441c6&"
import script from "./PhysicalPresenceTable.vue?vue&type=script&lang=js&"
export * from "./PhysicalPresenceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports